module.exports = __webpack_public_path__ + "static/ccd.02a40040.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/clients/ccd.png
// module id = 358
// module chunks = 154382131621592